import { createContext } from 'react';

export const SynthContext = createContext(null);

export default SynthContext;
